import { Component } from 'react'
import { browserHistory } from 'react-router'
import { connect } from 'react-redux'

import {
  endTutorial,
  hideDetailTransactionModal,
  hidePaymentGatewayErrorModal,
  pageRequest,
  showDetailTransactionModal,
  startTrial,
  verifyBilling
} from 'actions/ingredients/ingredientSubscription'
import styles from './Ingredient.css'
import FeatureTutorialPage from 'components/FeatureTutorialPage'
import FeatureBillingPage from 'components/FeatureBillingPage'
import FeatureTrialPage from 'components/FeatureTrialPage'
import FeatureBlockerPage from 'components/FeatureBlockerPage'

import IngredientLogo from 'assets/images/ic_ingredient.png'

const DISCOUNT_PRICE_LOWER_BOUND = 150000

class Ingredient extends Component {
  componentDidMount () {
    let {trialEndAt, outletSlot, expired, billingNotification, already_subscribed} = this.props

    if (!expired) {
      this.props.dispatch(pageRequest(trialEndAt, outletSlot, billingNotification, already_subscribed))
    } else {
      browserHistory.push('/settings/billing')
    }
  }

  render () {
    let {
      isIngredientActive,
      isOnTutorial,
      pageOnLoading,
      featureName,
      alreadySubscribed,
      featurePrice,
      featurePricePerMonths,
      currentOutletCount,
      buttonMessage,
      isButtonDisabled,
      pendingPaymentMessage,
      pendingOutletMessage,
      showDetailModal,
      outletList,
      showPaymentGatewayErrorModal,
      trialEndAt,
      isOwner
    } = this.props

    const expireTime = 365 // expire time 1 year
    const messages = pendingPaymentMessage !== null ? pendingPaymentMessage : pendingOutletMessage !== null ? pendingOutletMessage : null
    if (Cookies.get('labelNew') === 'true') {
      Cookies.set('labelNew', 'false', { path: '/', domain: '.mokapos.com', expires: expireTime })
    }
    return (
      <div className={`container ${styles['container']}`}>
        {
          !pageOnLoading && !isOwner && !isIngredientActive && <FeatureBlockerPage />
        }
        {
          !pageOnLoading && !isIngredientActive && !alreadySubscribed && !isOnTutorial && isOwner &&
          <FeatureTrialPage
            featureName={featureName}
            featurePricePerMonths={featurePricePerMonths}
            discountPriceLowerBound={DISCOUNT_PRICE_LOWER_BOUND}
            description='Keep track the ingredients of your items, and get notified when the ingredient is running out.'
            featureIcon={IngredientLogo}
            featureVideo='https://www.youtube.com/embed/0K_4_PeV4x8'
            startTrial={() => { this._startTrial() }}
            trialEndAt={trialEndAt}
          />
        }
        {
          !pageOnLoading && !isIngredientActive && alreadySubscribed && !isOnTutorial && isOwner &&
          <FeatureBillingPage
            featureName={featureName}
            discountPriceLowerBound={DISCOUNT_PRICE_LOWER_BOUND}
            videoLink='https://www.youtube.com/embed/0K_4_PeV4x8'
            featureMessage='Keep track the ingredients of your items, and get notified when the ingredient is running out.'
            featureLogo={IngredientLogo}
            featurePrice={featurePrice}
            featurePricePerMonths={featurePricePerMonths}
            currentOutletCount={currentOutletCount}
            buttonMessage={buttonMessage}
            isButtonDisabled={isButtonDisabled}
            billingMessages={messages}
            showDetailModal={showDetailModal}
            onHide={() => { this._onHide() }}
            onShow={() => { this._onShow() }}
            outletList={outletList}
            verifyBilling={() => { this._verifyBilling() }}
            showPaymentGatewayErrorModal={showPaymentGatewayErrorModal}
            hidePaymentGatewayErrorModal={() => { this._hidePaymentGatewayErrorModal() }}
          />
        }
        {
          !pageOnLoading && isOnTutorial && isOwner &&
          <FeatureTutorialPage
            featureName={`Welcome to ${featureName}`}
            isSubscribedAccount={alreadySubscribed}
            videoLink='https://www.youtube.com/embed/dSVg0quPPjo?ecver=1'
            endTutorial={() => { this._endTutorial() }}
          />
        }
        {!pageOnLoading && isIngredientActive && !isOnTutorial && this.props.children}
      </div>
    )
  }

  _endTutorial = () => {
    const {isOwner} = this.props
    if (isOwner) this.props.dispatch(endTutorial({feature_name: 'Ingredient Inventory'}))
  }

  _onHide = () => {
    const {isOwner} = this.props
    if (isOwner) this.props.dispatch(hideDetailTransactionModal())
  }

  _onShow = () => {
    const {isOwner} = this.props
    if (isOwner) this.props.dispatch(showDetailTransactionModal())
  }

  _verifyBilling = () => {
    const {featureName, featurePrice, isOwner} = this.props
    if (isOwner) {
      let featureData = {
        type: 'FeatureBilling',
        feature_name: featureName,
        total_amount: featurePrice.final_price
      }
      this.props.dispatch(verifyBilling(featureData))
    }
  }

  _hidePaymentGatewayErrorModal = () => {
    const {isOwner} = this.props
    if (isOwner) this.props.dispatch(hidePaymentGatewayErrorModal())
  }

  _startTrial = () => {
    const {isOwner} = this.props
    if (isOwner) this.props.dispatch(startTrial())
  }
}

function mapStateToProps (state) {
  const {already_subscribed, business: {trial_end_at, outlet_slot}, is_owner} = state.moka.user
  const {
    isOnTutorial,
    pageOnLoading,
    subscriptionDetail: {name, is_active},
    featurePrice, featurePricePerMonths,
    currentOutletCount,
    isButtonDisabled,
    buttonMessage,
    pendingPaymentMessage,
    pendingOutletMessage,
    showDetailModal,
    outletList,
    showPaymentGatewayErrorModal
  } = state.ingredients.ingredientSubscription
  const {expired} = state.subscriptionExpired
  const {billingNotification} = state
  return {
    alreadySubscribed: already_subscribed,
    trialEndAt: trial_end_at,
    outletSlot: outlet_slot,
    isOwner: is_owner,
    isOnTutorial,
    isIngredientActive: is_active,
    pageOnLoading,
    featureName: name,
    featurePrice,
    featurePricePerMonths,
    currentOutletCount,
    isButtonDisabled,
    buttonMessage,
    pendingPaymentMessage,
    pendingOutletMessage,
    showDetailModal,
    outletList,
    showPaymentGatewayErrorModal,
    expired,
    billingNotification
  }
}

export default connect(mapStateToProps)(Ingredient)



// WEBPACK FOOTER //
// ./app/pages/Ingredient/Ingredient.js